var _defs, _mask, _use, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeadPageFormBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1129px",
    height: "441px",
    viewBox: "0 0 1129 441",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "286E97CD-1D72-4FDD-993B-17F283955573") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "-3.91700561e-15 0 1129 0 1129 352 -3.91700561e-15 352"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 28.5,
    cy: 28.5,
    r: 28.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05E2\\u05DE\\u05D5\\u05D3-\\u05D4\\u05D8\\u05D1\\u05D4_\\u05D8\\u05D5\\u05E4\\u05E1_\\u05D8\\u05E7\\u05E1\\u05D8",
    transform: "translate(-400.000000, -634.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(400.000000, 634.552543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy",
    transform: "translate(0.000000, 88.447457)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2E2D79",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_472",
    opacity: 0.848795573,
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-865.573539, -958.591826)",
    id: "Group_55",
    opacity: 0.716634115
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1837",
    fill: "#9C9C9C",
    fillRule: "nonzero",
    opacity: 0.483816964
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1838",
    opacity: 0.504101563
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path_154",
    opacity: 0.6,
    style: {
      mixBlendMode: "overlay"
    },
    transform: "translate(1324.540200, 1169.606532) rotate(-62.157000) translate(-1324.540200, -1169.606532) ",
    points: "527.313875 174.693445 1880.57383 1607.47874 2121.76653 2164.51962 768.506475 731.733672"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_156",
    opacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    },
    transform: "translate(1577.826879, 1273.476134) rotate(-62.153378) translate(-1577.826879, -1273.476134) ",
    points: "1230.17045 895.867513 1910.21395 1615.82895 1925.48331 1651.08475 1245.4398 931.123321"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_157",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    },
    transform: "translate(2086.107620, 1100.633142) rotate(-62.115000) translate(-2086.107620, -1100.633142) ",
    points: "1743.6684 735.88814 2424.72496 1456.56598 2428.54684 1465.37814 1747.49028 744.700304"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_158",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay"
    },
    transform: "translate(1154.483613, 1132.249387) rotate(-62.153378) translate(-1154.483613, -1132.249387) ",
    points: "396.212111 227.149673 1749.1767 1659.57229 1912.75511 2037.3491 559.793123 604.926964"
  }))))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(130.410331, 64.957865) scale(1, -1) rotate(-15.000000) translate(-130.410331, -64.957865) translate(78.646532, 11.578603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_427-+-Line_428-+-Line_429-+-Line_430-+-Line_431-+-Line_432-+-Line_433-+-Line_434-+-Line_435-+-Line_436-+-Line_437-+-Line_438-+-Line_439-+-Line_440-+-Line_441-+-Line_442-Mask",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.6392403,
    y1: -12.9854083,
    x2: 71.9444908,
    y2: 32.3198421,
    id: "Line_427",
    stroke: "#CECECE",
    strokeWidth: 0.75,
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.9874271,
    y1: -10.3339281,
    x2: 69.2926776,
    y2: 34.9713224,
    id: "Line_428",
    stroke: "#CECECE",
    strokeWidth: 0.75,
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.3359468,
    y1: -7.68211482,
    x2: 66.6411973,
    y2: 37.6228027,
    id: "Line_429",
    stroke: "#CECECE",
    strokeWidth: 0.75,
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.6844665,
    y1: -5.03063454,
    x2: 63.989384,
    y2: 40.274283,
    id: "Line_430",
    stroke: "#CECECE",
    strokeWidth: 0.75,
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.0326533,
    y1: -2.37915426,
    x2: 61.3379037,
    y2: 42.9260962,
    id: "Line_431",
    stroke: "#CECECE",
    strokeWidth: 0.75,
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.381173,
    y1: 0.272658993,
    x2: 58.6864235,
    y2: 45.5779095,
    id: "Line_432",
    stroke: "#CECECE",
    strokeWidth: 0.75,
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.7293597,
    y1: 2.92413927,
    x2: 56.0346102,
    y2: 48.2293898,
    id: "Line_433",
    stroke: "#CECECE",
    strokeWidth: 0.75,
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.07787944,
    y1: 5.57595253,
    x2: 53.3831299,
    y2: 50.88087,
    id: "Line_434",
    stroke: "#CECECE",
    strokeWidth: 0.75,
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.42606619,
    y1: 8.2274328,
    x2: 50.7313167,
    y2: 53.5326833,
    id: "Line_435",
    stroke: "#CECECE",
    strokeWidth: 0.75,
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.77458591,
    y1: 10.8792461,
    x2: 48.0798364,
    y2: 56.1844965,
    id: "Line_436",
    stroke: "#CECECE",
    strokeWidth: 0.75,
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.122772656,
    y1: 13.5307263,
    x2: 45.4280231,
    y2: 58.8359768,
    id: "Line_437",
    stroke: "#CECECE",
    strokeWidth: 0.75,
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -2.52870762,
    y1: 16.1825396,
    x2: 42.7765429,
    y2: 61.4877901,
    id: "Line_438",
    stroke: "#CECECE",
    strokeWidth: 0.75,
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5.18052088,
    y1: 18.8340199,
    x2: 40.1243966,
    y2: 64.1392704,
    id: "Line_439",
    stroke: "#CECECE",
    strokeWidth: 0.75,
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -7.83200115,
    y1: 21.4858331,
    x2: 37.4732493,
    y2: 66.7910836,
    id: "Line_440",
    stroke: "#CECECE",
    strokeWidth: 0.75,
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10.4838144,
    y1: 24.1373134,
    x2: 34.8214361,
    y2: 69.4425639,
    id: "Line_441",
    stroke: "#CECECE",
    strokeWidth: 0.75,
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -13.1352947,
    y1: 26.7891267,
    x2: 32.1699558,
    y2: 72.0943771,
    id: "Line_442",
    stroke: "#CECECE",
    strokeWidth: 0.75,
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2E2D79",
    opacity: 0.107979911,
    cx: 58.0275985,
    cy: 61.2585245,
    r: 45.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadPageFormBackground);
export default __webpack_public_path__ + "static/media/lead_page_form_background.a08ee76a468a57f754bfbb891ffefd87.svg";
export { ForwardRef as ReactComponent };